(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cx-ra-product-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-cx-ra-product-grid-toggle]');
    if (!button) return;
    const grid = button.closest('[data-cx-ra-product-grid]');
    if (!grid) return;
    const expanded = grid.classList.toggle('cx-mobile-grid--expanded');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.showLessText : button.dataset.showMoreText;
  });
  } catch(e) { console.error(e); }
})();

})();
